import type { Column, Table } from '@tanstack/react-table';
import type { ReactNode } from 'react';
import { DataTableHeaderCellDate } from './date/component/index.js';
import { DataTableHeaderCellNumber } from './number/component/index.js';
import { DataTableHeaderCellSelect } from './select/component/index.js';
import { DataTableHeaderCellStringArray } from './string-array/component/index.js';
import { DataTableHeaderCellString } from './string/component/index.js';

type DataTableHeaderCellProps<TData, TValue> = {
    tableId: string;
    table: Table<TData>;
    column: Column<TData, TValue>;
    title: ReactNode;
    tooltip?: ReactNode;
};

export function DataTableHeaderCell<TData, TValue>({
    tableId,
    table,
    column,
    title,
    tooltip,
}: DataTableHeaderCellProps<TData, TValue>) {
    const filter = column.columnDef.meta?.filter;

    switch (filter?.type) {
        case 'date': {
            return (
                <DataTableHeaderCellDate
                    tableId={tableId}
                    table={table}
                    column={column}
                    title={title}
                    tooltip={tooltip}
                />
            );
        }
        case 'number': {
            return (
                <DataTableHeaderCellNumber
                    tableId={tableId}
                    table={table}
                    column={column}
                    title={title}
                    tooltip={tooltip}
                />
            );
        }
        case 'select':
            return <DataTableHeaderCellSelect column={column} title={title} tooltip={tooltip} />;
        case 'string': {
            return (
                <DataTableHeaderCellString
                    tableId={tableId}
                    table={table}
                    column={column}
                    title={title}
                    tooltip={tooltip}
                />
            );
        }
        case 'string-array': {
            return (
                <DataTableHeaderCellStringArray
                    tableId={tableId}
                    table={table}
                    column={column}
                    title={title}
                    tooltip={tooltip}
                />
            );
        }
        default:
            return title;
    }
}
